import { ShieldCheck, UserCheck, LockKeyhole, Star, ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const PILLARS = [
  {
    icon: ShieldCheck,
    title: "Identity Verified",
    text: "Users can verify their identity through our verification system.",
  },
  {
    icon: UserCheck,
    title: "18+ Community",
    text: "Our platform is designed for adults aged 18 and over.",
  },
  {
    icon: LockKeyhole,
    title: "Secure Payments",
    text: "Payments are handled securely through our payment provider.",
  },
  {
    icon: Star,
    title: "Real Reviews",
    text: "See ratings and reviews from previous customers.",
  },
];

export default function Trust() {
  return (
    <section id="safety" data-testid="trust-section" className="relative bg-navy py-20 md:py-28 overflow-hidden">
      <div className="absolute top-0 right-0 w-[480px] h-[480px] rounded-full bg-teal/10 blur-3xl pointer-events-none" />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 relative">
        <Reveal className="max-w-2xl">
          <Eyebrow dark>Trust & safety</Eyebrow>
          <h2 className="mt-4 font-display font-extrabold tracking-tight text-white text-3xl sm:text-4xl lg:text-5xl">
            Built around trust.
          </h2>
          <p className="mt-4 text-base sm:text-lg text-slate-300 leading-relaxed">
            We believe getting help from someone you don't know should still feel safe.
          </p>
        </Reveal>

        <div className="mt-12 md:mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {PILLARS.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.1}>
              <div
                data-testid={`trust-card-${p.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="group h-full rounded-2xl bg-white/[0.04] border border-white/10 backdrop-blur-sm p-7 hover:bg-white/[0.08] hover:border-teal/40 transition-[background-color,border-color] duration-300"
              >
                <span className="w-12 h-12 rounded-xl bg-teal/15 grid place-items-center group-hover:bg-teal transition-colors duration-300">
                  <p.icon className="w-5 h-5 text-teal-light group-hover:text-white transition-colors duration-300" />
                </span>
                <h3 className="mt-6 font-display font-bold text-white text-lg">{p.title}</h3>
                <p className="mt-2.5 text-sm text-slate-400 leading-relaxed">{p.text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <a
            href="#help"
            data-testid="trust-learn-safety-btn"
            className="group mt-10 inline-flex items-center gap-2 text-sm font-semibold text-teal-light hover:text-white transition-colors duration-200"
          >
            Learn about safety
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-200" />
          </a>
        </Reveal>
      </div>
    </section>
  );
}
